import Gallery from "webPage/Gallery";

export function handleTestimonialSlider(){
    let $testimonialGallery = $('.js-testimonials');

    if ($testimonialGallery.length > 0) {
        let $gallery = new Gallery($testimonialGallery, {
            itemClass:          "testimonials__slide",
            pipClass:           "pip__item",
            navigateClass:      "js-navigate",
            pipsClass:          "js-pips",
            itemsClass:         "js-items",
            itemActiveModifier: "active",
            pipActiveModifier:  "active",
            animationDuration:  400,
            applyMinHeight:     false,
            keyboardEvents:     false,
        });

        $gallery.on('transitionStart', ({from, to, direction}) => {
            //Add relevant classes to the image

            let $image = $('.js-testimonials-image');
            let $from = $image.eq(from);
            let $to = $image.eq(to);

            $from.addClass('testimonials__image--out-' + direction);
            $to.addClass('testimonials__image--active testimonials__image--in-' + direction);
        }).on('transitionEnd', ({from, to, direction}) => {
            //Remove relevant classes to the image

            let $image = $('.js-testimonials-image');
            let $from = $image.eq(from);
            let $to = $image.eq(to);

            $from.removeClass('testimonials__image--active testimonials__image--out-' + direction);
            $to.removeClass('testimonials__image--in-' + direction);
        });
    }
}
